// extracted by mini-css-extract-plugin
module.exports = {"tickerBanner":"styles_tickerBanner__EqDRd","tickerDiv":"styles_tickerDiv__IfGJH","phrase":"styles_phrase__JO4SB"};